// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Panel__tabs {
  display: grid;
  gap: 16px;
}
.n-Panel__tab-switch {
  width: fit-content;
  max-width: 100%;
  overflow-x: auto;
}
.n-Panel__tab-switch-button {
  min-width: 0;
}
.n-Panel__tab-panels {
  min-width: 0;
}
.n-Panel__tab-panels--reserved {
  display: grid;
}
.n-Panel__tab-panel {
  min-width: 0;
}
.n-Panel__tab-panels--reserved > .n-Panel__tab-panel {
  grid-area: 1 / 1;
  visibility: hidden;
  pointer-events: none;
}
.n-Panel__tab-panels--reserved > .n-Panel__tab-panel--active {
  visibility: visible;
  pointer-events: auto;
}
@media (max-width: 760px) {
  .n-Panel__tab-switch {
    width: 100%;
  }
  .n-Panel__tab-switch-button {
    flex: 1 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/panel/PanelTabs.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANE;EACE,aAAA;EACA,SAAA;AAQJ;AALE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAOJ;AAJE;EACE,YAAA;AAMJ;AAHE;EACE,YAAA;AAKJ;AAHI;EACE,aAAA;AAKN;AADE;EACE,YAAA;AAGJ;AAAE;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;AAEJ;AACE;EACE,mBAAA;EACA,oBAAA;AACJ;AAGA;EAEI;IACE,WAAA;EAFJ;EAKE;IACE,cAAA;EAHJ;AACF","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import '~venus';\n\n.n-Panel {\n  &__tabs {\n    display: grid;\n    gap: @layoutUnit-md;\n  }\n\n  &__tab-switch {\n    width: fit-content;\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  &__tab-switch-button {\n    min-width: 0;\n  }\n\n  &__tab-panels {\n    min-width: 0;\n\n    &--reserved {\n      display: grid;\n    }\n  }\n\n  &__tab-panel {\n    min-width: 0;\n  }\n\n  &__tab-panels--reserved > &__tab-panel {\n    grid-area: 1 / 1;\n    visibility: hidden;\n    pointer-events: none;\n  }\n\n  &__tab-panels--reserved > &__tab-panel--active {\n    visibility: visible;\n    pointer-events: auto;\n  }\n}\n\n@media (max-width: 760px) {\n  .n-Panel {\n    &__tab-switch {\n      width: 100%;\n    }\n\n    &__tab-switch-button {\n      flex: 1 0 auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
